import React, { useState, useEffect, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotRemoveData,
  updatePassword,
} from "reduxStore/action/authActions";
import { seo } from "utils/utils";
import AuthShell from "../AuthShell";

const Resetpassword = () => {
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);
  const [passShown, setPassShown] = useState(false);
  const [formInput, setFormInput] = useState({
    password: "",
    confirmPassword: "",
  });

  const [formError, setFormError] = useState({
    password: "",
    confirmPassword: "",
  });

  const dispatch = useDispatch();

  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};

  const updatePasswordData = async () => {
    const { response, reset = false } = forgotPasswordSelector || {};
    if (response && reset) {
      if (response?.status === 200) {
        dispatch(forgotRemoveData());
        navigate("/login");
      }
    }
  };

  const handleUserInput = (name, value) => {
    setFormInput({
      ...formInput,
      [name]: value,
      email: forgotPasswordSelector.data.email,
    });
  };

  const handleEnterPressFromFirst = (event) => {
    if (event.key === "Enter") {
      const next = document.getElementById("reset_confirm");
      next?.focus();
    }
  };

  const handleEnterPressFromSecond = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      submitReset();
    }
  };

  useEffect(() => {
    updatePasswordData();
  }, [forgotPasswordSelector]);

  const validateFormInput = () => {
    let inputError = {
      password: "",
      confirmPassword: "",
    };

    if (!formInput.password) {
      setFormError({
        ...inputError,
        password: strings.emptypassword,
      });
      return false;
    }

    if (formInput.confirmPassword !== formInput.password) {
      setFormError({
        ...inputError,
        confirmPassword: strings.confirmPasswordError,
      });
      return false;
    }

    setFormError(inputError);
    return true;
  };

  const submitReset = () => {
    if (validateFormInput()) {
      dispatch(updatePassword(formInput));
    }
  };

  useEffect(() => {
    seo({
      title: "Change Password",
      metaDescription: "Change password",
      canonicalLink: window.location.href,
    });
  }, []);

  const canSubmit =
    Boolean(formInput.password) && Boolean(formInput.confirmPassword);

  return (
    <Fragment>
      <AuthShell
        title={strings.changepass}
        subtitle={strings.enterNewPass}
        onBackToLogin={() => {
          dispatch(forgotRemoveData());
          navigate("/");
        }}
      >
        <form
          className="justo-login__form"
          onSubmit={(e) => {
            e.preventDefault();
            submitReset();
          }}
        >
          <div className="justo-login__field">
            <label className="justo-login__label" htmlFor="reset_password">
              {strings.newPass}
              <span className="justo-login__required" aria-hidden="true">
                *
              </span>
            </label>
            <div className="justo-login__input-group">
              <input
                className="form-control justo-login__input justo-login__input--password"
                id="reset_password"
                autoComplete="new-password"
                type={passwordShown ? "text" : "password"}
                value={formInput.password}
                name="password"
                placeholder={strings.newPass}
                onChange={({ target }) => {
                  handleUserInput(target.name, target.value);
                }}
                onKeyDown={handleEnterPressFromFirst}
              />
              <button
                type="button"
                className="justo-login__password-toggle"
                onClick={() => setPasswordShown(!passwordShown)}
                aria-label={passwordShown ? "Hide password" : "Show password"}
              >
                <i
                  className={passwordShown ? "fa fa-eye" : "fa fa-eye-slash"}
                  aria-hidden="true"
                />
              </button>
            </div>
            {formError.password ? (
              <span className="justo-login__error">{formError.password}</span>
            ) : null}
          </div>

          <div className="justo-login__field">
            <label className="justo-login__label" htmlFor="reset_confirm">
              {strings.confirmPass}
              <span className="justo-login__required" aria-hidden="true">
                *
              </span>
            </label>
            <div className="justo-login__input-group">
              <input
                className="form-control justo-login__input justo-login__input--password"
                id="reset_confirm"
                autoComplete="new-password"
                type={passShown ? "text" : "password"}
                value={formInput.confirmPassword}
                name="confirmPassword"
                placeholder={strings.confirmPass}
                onChange={({ target }) => {
                  handleUserInput(target.name, target.value);
                }}
                onKeyDown={handleEnterPressFromSecond}
              />
              <button
                type="button"
                className="justo-login__password-toggle"
                onClick={() => setPassShown(!passShown)}
                aria-label={passShown ? "Hide password" : "Show password"}
              >
                <i
                  className={passShown ? "fa fa-eye" : "fa fa-eye-slash"}
                  aria-hidden="true"
                />
              </button>
            </div>
            {formError.confirmPassword ? (
              <span className="justo-login__error">
                {formError.confirmPassword}
              </span>
            ) : null}
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block justo-login__submit"
            disabled={!canSubmit}
          >
            {strings.changepassword}
          </button>
        </form>
      </AuthShell>
    </Fragment>
  );
};

export default Resetpassword;
